
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/texas-bellabot",
      function () {
        return require("private-next-pages/texas-bellabot/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/texas-bellabot"])
      });
    }
  